module.exports = __webpack_public_path__ + "static/media/noun-arrow-2304592.e95d1dc1.svg";